const label = "CONTENT.FUNCTIONS.";

const functions = [
    {
        id: 1,
        functionName: "RemoveHTML",
        label: label + "REMOVE-HTML.LABEL",
        fields: [{
            label: label + "SOURCE",
            description: "",
            isRequired: true,
            type: "string"
        }, {
            label: label + "REMOVE-HTML.KEEPBR",
            description: "",
            format: "%",
            isRequired: false,
            checkbox: [{ value: false, replaced: "false" }, { value: true, replaced: "true" }],
            type: "checkbox"
        }]
    },
    {
        id: 2,
        functionName: "Sum",
        label: label + "SUM.LABEL",
        fields: [{
            label: label + "FIRST-NUMBER",
            description: label + "NUMBER-DESCRIPTION",
            isRequired: true,
            type: "number"
        }, {
            label: label + "SECOND-NUMBER",
            description: label + "NUMBER-DESCRIPTION",
            isRequired: true,
            type: "number"
        },
        {
            label: label + "PRECISION",
            description: label + "PRECISION-DESCRIPTION",
            isRequired: true,
            defaultValue: "0",
            type: "number"
        }]
    },
    {
        id: 3,
        functionName: "Difference",
        label: label + "DIFFERENCE.LABEL",
        fields: [{
            label: label + "FIRST-NUMBER",
            description: label + "NUMBER-DESCRIPTION",
            isRequired: true,
            type: "number"
        }, {
            label: label + "SECOND-NUMBER",
            description: label + "NUMBER-DESCRIPTION",
            isRequired: true,
            type: "number"
        },
        {
            label: label + "PRECISION",
            description: label + "PRECISION-DESCRIPTION",
            isRequired: true,
            defaultValue: "0",
            type: "number"
        }]
    },

    {
        id: 4,
        functionName: "Multiply",
        label: label + "MULTIPLY.LABEL",
        fields: [{
            label: label + "FIRST-NUMBER",
            description: label + "NUMBER-DESCRIPTION",
            isRequired: true,
            type: "number"
        }, {
            label: label + "SECOND-NUMBER",
            description: label + "NUMBER-DESCRIPTION",
            isRequired: true,
            type: "number"
        },
        {
            label: label + "PRECISION",
            description: label + "PRECISION-DESCRIPTION",
            isRequired: true,
            defaultValue: "0",
            type: "number"
        }]
    },

    {
        id: 5,
        functionName: "Divide",
        label: label + "DIVIDE.LABEL",
        fields: [{
            label: label + "FIRST-NUMBER",
            description: label + "NUMBER-DESCRIPTION",
            isRequired: true,
            type: "number"
        }, {
            label: label + "SECOND-NUMBER",
            description: label + "NUMBER-DESCRIPTION",
            isRequired: true,
            type: "number"
        },
        {
            label: label + "PRECISION",
            description: label + "PRECISION-DESCRIPTION",
            isRequired: true,
            defaultValue: "0",
            type: "number"
        }]
    },


    {
        id: 6,
        functionName: "UpperCase",
        label: label + "UPPERCASE.LABEL",
        fields: [{
            label: label + "SOURCE",
            description: "",
            isRequired: true,
            type: "string"
        }]
    },

    {
        id: 7,
        functionName: "LowerCase",
        label: label + "LOWERCASE.LABEL",
        fields: [{
            label: label + "SOURCE",
            description: "",
            isRequired: true,
            type: "string"
        }]
    },


    {
        id: 8,
        functionName: "Capitalize",
        label: label + "CAPITALIZE.LABEL",
        fields: [{
            label: label + "SOURCE",
            description: "",
            isRequired: true,
            type: "string"
        }]
    },

    {
        id: 9,
        functionName: "Replace",
        label: label + "REPLACE.LABEL",
        fields: [
            {
                label: label + "SOURCE",
                description: "",
                isRequired: true,
                type: "string"
            },
            {
                label: label + "REPLACE.OLD-VALUE",
                description: "",
                isRequired: true,
                type: "string"
            },
            {
                label: label + "REPLACE.REPLACED-VALUE",
                description: "",
                isRequired: true,
                type: "string"
            },
            {
                label: label + "REPLACE.NUMBER-OF-REPLACEMENTS",
                description: label + "PRECISION-DESCRIPTION",
                isRequired: false,
                type: "number"
            }
        ]
    },
    {
        id: 10,
        functionName: "Contains",
        label: label + "CONTAINS.LABEL",
        fields: [
            {
                label: label + "SOURCE",
                description: "",
                isRequired: true,
                type: "string"
            },
            {
                label: label + "CONTAINS.SUBSTR",
                description: "",
                isRequired: true,
                type: "string"
            }
        ]
    },

    {
        id: 11,
        functionName: "Ceil",
        label: label + "CEIL.LABEL",
        fields: [
            {
                label: label + "SOURCE",
                description: label + "NUMBER-DESCRIPTION",
                isRequired: true,
                type: "number"
            },
            {
                label: label + "PRECISION",
                description: label + "PRECISION-DESCRIPTION",
                isRequired: true,
                type: "number"
            }
        ]
    },

    {
        id: 12,
        functionName: "Avg",
        label: label + "AVG.LABEL",
        fields: [
            {
                label: label + "AVG.NUMBERS",
                description: label + "AVG.NUMBERS-DESCRIPTION",
                isRequired: true,
                type: "array"
            },
            {
                label: label + "PRECISION",
                description: label + "PRECISION-DESCRIPTION",
                isRequired: false,
                type: "number"
            }
        ]
    },

    {
        id: 13,
        functionName: "Mod",
        label: label + "MOD.LABEL",
        fields: [
            {
                label: label + "FIRST-NUMBER",
                description: label + "NUMBER-DESCRIPTION",
                isRequired: true,
                type: "number"
            },
            {
                label: label + "SECOND-NUMBER",
                description: label + "NUMBER-DESCRIPTION",
                isRequired: true,
                type: "number"
            },
            {
                label: label + "PRECISION",
                description: label + "PRECISION-DESCRIPTION",
                isRequired: false,
                type: "number"
            }
        ]
    },

    {
        id: 14,
        functionName: "PowerOf",
        label: label + "POWER-OF.LABEL",
        fields: [
            {
                label: label + "POWER-OF.BASE-NUMBER",
                description: label + "NUMBER-DESCRIPTION",
                isRequired: true,
                type: "number"
            },
            {
                label: label + "POWER-OF.EXPONENT",
                description: label + "NUMBER-DESCRIPTION",
                isRequired: true,
                type: "number"
            },
            {
                label: label + "PRECISION",
                description: label + "PRECISION-DESCRIPTION",
                isRequired: false,
                type: "number"
            }
        ]
    },
    {
        id: 15,
        functionName: "Abs",
        label: label + "ABS.LABEL",
        fields: [
            {
                label: label + "SOURCE",
                description: label + "NUMBER-DESCRIPTION",
                isRequired: true,
                type: "number"
            },
            {
                label: label + "PRECISION",
                description: label + "PRECISION-DESCRIPTION",
                isRequired: false,
                type: "number"
            }
        ]
    },
    {
        id: 16,
        functionName: "Round",
        label: label + "ROUND.LABEL",
        fields: [
            {
                label: label + "SOURCE",
                description: label + "NUMBER-DESCRIPTION",
                isRequired: true,
                type: "number"
            },
            {
                label: label + "PRECISION",
                description: label + "PRECISION-DESCRIPTION",
                isRequired: false,
                type: "number"
            }
        ]
    },
    {
        id: 17,
        functionName: "IsEven",
        label: label + "IS-EVEN.LABEL",
        fields: [
            {
                label: label + "SOURCE",
                description: label + "IS-EVEN.NUMBER-DESCRIPTION",
                isRequired: true,
                type: "number"
            },
        ]
    },
    {
        id: 18,
        functionName: "IsOdd",
        label: label + "IS-ODD.LABEL",
        fields: [
            {
                label: label + "SOURCE",
                description: label + "IS-ODD.NUMBER-DESCRIPTION",
                isRequired: true,
                type: "number"
            },
        ]
    },
    {
        id: 19,
        functionName: "Floor",
        label: label + "FLOOR.LABEL",
        fields: [
            {
                label: label + "SOURCE",
                description: label + "NUMBER-DESCRIPTION",
                isRequired: true,
                type: "number"
            },
            {
                label: label + "PRECISION",
                description: label + "PRECISION-DESCRIPTION",
                isRequired: false,
                type: "number"
            }
        ]
    },
    {
        id: 20,
        functionName: "ToFloat",
        label: label + "TO-FLOAT.LABEL",
        fields: [
            {
                label: label + "SOURCE",
                description: label + "NUMBER-DESCRIPTION",
                isRequired: true,
                type: "number"
            },
            {
                label: label + "PRECISION",
                description: label + "PRECISION-DESCRIPTION",
                isRequired: false,
                type: "number"
            }
        ]
    },
    {
        id: 21,
        functionName: "ToInt",
        label: label + "TO-INT.LABEL",
        fields: [
            {
                label: label + "SOURCE",
                description: label + "NUMBER-DESCRIPTION",
                isRequired: true,
                type: "number"
            },
        ]
    },
    {
        id: 22,
        functionName: "ToStr",
        label: label + "TO-STR.LABEL",
        fields: [
            {
                label: label + "SOURCE",
                description: "",
                isRequired: true,
                type: "date"
            },
            {
                label: label + "TO-STR.DATE-TYPE",
                description: "",
                options: [{ label: label + "TO-STR.SHORT", value: "short" }, { label: label + "TO-STR.LONG", value: "long" }],

                isRequired: false,
                type: "select"
            },
        ]
    },
    {
        id: 23,
        functionName: "ToCurrency",
        label: label + "TO-CURRENCY.LABEL",
        fields: [
            {
                label: label + "SOURCE",
                description: label + "NUMBER-DESCRIPTION",
                isRequired: true,
                type: "number"
            },
            {
                label: label + "PRECISION",
                description: label + "PRECISION-DESCRIPTION",
                format: "precision:%",
                isRequired: false,
                type: "number"
            },
            {
                label: label + "TO-CURRENCY.UNIT",
                description: label + "TO-CURRENCY.UNIT-DESCRIPTION",
                format: "unit:%",
                isRequired: false,
                type: "string"
            },
            {
                label: label + "TO-CURRENCY.DELIMITER",
                description: "",
                format: "delimiter:%",
                isRequired: false,
                type: "string"
            },
            {
                label: label + "TO-CURRENCY.FORMAT", // unit değerini yazının sağına koy
                description: label + "TO-CURRENCY.FORMAT-DESCRIPTION",
                format: "format:%",
                checkbox: [{ value: false, replaced: "" }, { value: true, replaced: "vu" }], // hem save işleminde hemde update tuşuna basıldığında eski verileri getirirken kullanılacak.
                isRequired: false,
                defaultValue: false,
                type: "checkbox"
            },
            {
                label: label + "TO-CURRENCY.SEPERATOR",
                description: "",
                format: "seperator:%",
                isRequired: false,
                type: "string"
            }
        ]
    },
    {
        id: 24,
        functionName: "ToPhone",
        label: label + "TO-PHONE.LABEL",
        fields: [
            {
                label: label + "SOURCE",
                description: label + "NUMBER-DESCRIPTION",
                isRequired: true,
                type: "number"
            },
            {
                label: label + "DELIMITER",
                description: "",
                format: "delimiter:%",
                isRequired: false,
                type: "string"
            },
            {
                name: "country_code",
                label: label + "TO-PHONE.C-CODE",
                description: label + "NUMBER-DESCRIPTION",
                format: "c_code:%",
                isRequired: false,
                type: "number"
            },
            {
                label: label + "TO-PHONE.C-CODE-SYMBOL",
                description: "",
                format: "%",
                isRequired: false,
                checkbox: [{ value: false, replaced: "" }, { value: true, replaced: "c_code_symbol" }],
                defaultValue: false,
                type: "checkbox"
            },
            {
                name: "area_code",
                label: label + "TO-PHONE.A-CODE", // unit değerini yazının sağına koy
                description: "",
                format: "%",
                checkbox: [{ value: false, replaced: "" }, { value: true, replaced: "a_code" }], // hem save işleminde hemde update tuşuna basıldığında eski verileri getirirken kullanılacak.
                isRequired: false,
                defaultValue: false,
                type: "checkbox"
            },
            {
                label: label + "TO-PHONE.FORMAT",
                description: label + "TO-PHONE.FORMAT-DESCRIPTION",
                format: "format:%",
                isRequired: false,
                type: "phoneFormat"
            },
        ]
    },
    /*
        1) format girmek istediğinde. c_code girildiyse. en başa birtane * eklenir. Ve bu alan readonly olur.Disabled.
        örn: * (*******) *** ****
        2) alan kodu alanı parantez içerisine yazıyor gibi olmalı. fakat arkatarafa format içerisinde gönderilirken normal *** gitmeli.
        3) kullanıcının girdiği tüm alanlar birleştirilip gönderilmeli. Boşluklar aynı kalmalı. Alan kodu ile numara arasında boşluk		
    	
    
        // 3 alan kullanılacak.
        // ülke kodu => c_code
        // alan kodu => a_code 
        // numara => 
    */


]

export const getAllMathFunctions = () => {
    return functions;
}


export const mathFunctionGetById = (id) => {
    return functions.find(x => x.id === id);
}